<template>
  <div class="search-container">
    <!-- 顶部 -->
    <div class="search-top">
      <div class="search-list">
        <span>学段：</span>
        <ul class="search-list-item">
          <li v-for="item in sectionList" :key="item.id" :class="sectionId == item.id ? 'active' : ''" @click="selectSection(item)">
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="search-list">
        <span>学科：</span>
        <ul class="search-list-item" :class="isMoreSubject ? '' : 'fh'">
          <li v-for="item in subjectList" :key="item.id" :class="subjectId == item.id ? 'active' : ''" @click="selectSubject(item)">
            {{ item.label }}
          </li>
        </ul>
        <span class="moreBtn" v-if="subjectList.length > 14" @click="toggleMoreSubject"
          ><a href="javascript:;">更多<i :class="isMoreSubject ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></a
        ></span>
      </div>
      <div class="search-list">
        <span>类型：</span>
        <ul class="search-list-item" :class="isMoreType ? '' : 'fh'">
          <li v-for="item in typeList" :key="item.id" :class="typeId == item.id ? 'active' : ''" @click="selectType(item)">
            {{ item.label }}
          </li>
        </ul>
        <span class="moreBtn" v-if="typeList.length > 14" @click="toggleMoreType"
          ><a href="javascript:;">更多<i :class="isMoreType ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></a
        ></span>
      </div>
    </div>
    <!-- 中间 -->
    <div class="search-mid">
      <div class="search-size-group">
        <span v-for="item in exerciseSize" :key="item.value" :class="exerciseSizeIndex == item.value ? 'active' : ''" @click="toggleFilterSize(item)">{{ item.label }} <i class="iconfont icon-xiayi"></i></span>
      </div>
      <div class="search-totalSize">共 {{ total }} 条结果</div>
    </div>
    <!-- 试题列表 -->
    <div class="search-bot">
      <div v-if="loadingFlag" class="myLoading">
        <i class="el-icon-loading"></i>
      </div>
      <div class="search-question-list" v-if="exerciseList.length > 0">
        <!-- 有数据 -->
        <!-- 试题组件 -->
        <question :questionList="exerciseList" :stageId="sectionId" :subjectId="subjectId" :basketPaperId="shoppingCartList.paper_id" :basketTotal="shoppingCartList.total" @refreshExercisesList="refreshExercisesList" @refreshCartList="refreshCartList"></question>
        <!-- 分页 -->
        <div class="search-question-list-page">
          <pagination name="searchListPage" :total="total" :current-page="currentPage" :pageSize="10" @change="currentPageChange"></pagination>
        </div>
      </div>
      <!-- 无数据 -->
      <div class="search-question-list-empty" v-else>
        <p><i class="iconfont icon-wushuju"></i></p>
        <p>筛选无结果，换个条件试试吧</p>
      </div>
    </div>
    <!-- 试题篮组件 -->
    <shopping-cart :shoppingCartList="shoppingCartList" @refreshExercisesList="refreshExercisesList"></shopping-cart>
  </div>
</template>

<script>
var that
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import shoppingCart from '@/components/shoppingCar.vue'
import question from '@/components/question.vue'
import pagination from '@/components/pagination.vue'
import { showLoading, hideLoading } from '../utils/loading.js'
import * as util from '../utils/util.js'
import { questionSearchOptions, questionSearch, shoppingCartList } from '@/api/manual'
export default {
  name: 'search',
  data() {
    return {
      sectionId: '',
      sectionList: [],
      subjectId: '',
      subjectList: [],
      typeId: 0,
      typeList: [],
      isMoreSubject: true, // 更多学科按钮
      isMoreType: true, // 更多类型按钮

      exerciseSizeIndex: 'time',
      exerciseSize: [
        // 试题次数
        { label: '最新', value: 'time' },
        { label: '组卷次数', value: 'used_num' },
      ],

      keyword: '', // 搜索关键词

      exerciseList: [], // 试题列表数据
      currentPage: 1,
      total: 0,

      shoppingCartList: {
        // 试题篮列表
        data: [],
        paper_id: '',
        total: 0,
      },
      loadingFlag: false,
      optsParentWidth: 1160, // 选项父容器的宽度
    }
  },
  beforeRouteEnter(to, from, next) {
    // 每次进入路由都执行一次
    next(vm => {
      vm.$nextTick(() => {
        if (Cookies.get('filters')) {
          let filters = Cookies.get('filters').split(',')
          console.log(filters)
          if (filters[0]) {
            that.sectionId = filters[0]
          }
          if (filters[1]) {
            that.subjectId = filters[1]
          }
        } else {
          that.sectionId = 1
          that.subjectId = 2
        }
        that.getQuestionSeacchOptions(true)
        vm.getQuestionsList(vm.currentPage)
      })
    })
  },
  created() {
    that = this
    that.keyword = that.$route.query.keyword
  },
  computed: {
    ...mapGetters(['baseLink', 'userInfo']),
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        that.keyword = val.query.keyword
        if (that.keyword) {
          that.currentPage = 1
          that.getQuestionsList(that.currentPage)
        }
      },
      deep: true,
    },
  },
  components: {
    shoppingCart,
    question,
    pagination,
  },
  methods: {
    /* ------------------------------------------- 功能交互 ------------------------------------------- */

    selectSection(item) {
      // 选中学段
      that.sectionId = item.id
      that.getQuestionSeacchOptions()
    },
    toggleMoreSubject() {
      // 切换更多学科
      that.isMoreSubject = !that.isMoreSubject
    },
    selectSubject(item) {
      // 选中学科
      that.subjectId = item.id
      that.getQuestionSeacchOptions()
    },
    toggleMoreType() {
      // 切换更多类型
      that.isMoreType = !that.isMoreType
    },
    selectType(item) {
      // 选中类型
      that.typeId = item.id
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    toggleFilterSize(item) {
      // toggle最新和下载次数
      that.exerciseSizeIndex = item.value
      that.currentPage = 1
      that.getQuestionsList(that.currentPage)
    },
    currentPageChange(page) {
      that.currentPage = page.curPage
      window.scrollTo(0, 0)
      that.getQuestionsList(that.currentPage)
    },
    refreshExercisesList(val) {
      // 子组件删除触发父组件刷新试题列表
      if (val) {
        that.getQuestionsList(that.currentPage, true)
        that.getShoppingCartList(that.sectionId, that.subjectId)
      }
    },
    refreshCartList(val) {
      // 试题子组件触发父组件刷新试题篮列表
      if (val) {
        that.getShoppingCartList(that.sectionId, that.subjectId)
      }
    },

    /* ------------------------------------------- 请求接口 ------------------------------------------- */

    getQuestionSeacchOptions(flag) {
      // 获取试题选项
      let data = {
        stage_id: that.sectionId,
        subject_id: that.subjectId,
      }
      return new Promise((resolve, reject) => {
        questionSearchOptions(data).then(res => {
          if (res.code === 200) {
            that.isMoreSubject = true
            that.isMoreType = true
            that.sectionList = res.data.stages
            that.subjectList = res.data.subjects
            that.typeList = res.data.types
            let obj = {
              id: 0,
              label: '全部',
            }
            that.typeList.unshift(obj)
            if (!flag) {
              // 初始化不调用
              that.currentPage = 1
              that.getQuestionsList(that.currentPage) // 获取试题列表
            }
            that.getShoppingCartList(that.sectionId, that.subjectId)
          }
        })
      })
    },
    getQuestionsList(page, type) {
      // 查询试题列表
      if (!type) {
        that.loadingFlag = true
      }
      let data = {
        stage_id: that.sectionId,
        subject_id: that.subjectId,
        keyword: that.keyword,
        topic_id: that.typeId,
        sort: that.exerciseSizeIndex,
        page: that.currentPage,
      }
      return new Promise((resolve, reject) => {
        questionSearch(data)
          .then(res => {
            that.loadingFlag = false
            if (res.code === 200) {
              that.exerciseList = res.data.data
              that.total = res.data.total
              that.$nextTick(() => {
                util.setMoreMask(that.exerciseList, that) // 设置更多遮罩
                util.getOptionsWidth(that.exerciseList, that.optsParentWidth, that)
              })
            }
          })
          .catch(err => {
            that.loadingFlag = false
          })
      })
    },
    getShoppingCartList(stage_id, subject_id) {
      // 获取购物车列表
      let data = {
        stage_id: stage_id,
        subject_id: subject_id,
      }
      return new Promise((resolve, reject) => {
        shoppingCartList(data).then(res => {
          if (res.code === 200) {
            that.shoppingCartList = res.data
          }
        })
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-container {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 100px;
  .highlight {
    color: red !important;
  }
  .search-top {
    box-sizing: border-box;
    padding: 0 20px;
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
    .search-list {
      position: relative;
      overflow: hidden;
      font-size: 14px;
      & > span {
        float: left;
        width: 50px;
        height: 100%;
        line-height: 40px;
        text-align: right;
        color: #808080;
        & > a {
          font-size: 12px;
          & > i {
            padding-left: 6px;
          }
        }
      }
      .moreBtn {
        position: absolute;
        right: 0;
        top: 0;
        height: 40px;
        a:hover {
          color: #2b99ff;
        }
      }
      & > .search-list-item {
        box-sizing: border-box;
        overflow: hidden;
        margin-bottom: 1px;
        padding: 0 50px 0 20px;
        height: 40px;
        &.fh {
          height: auto;
          margin-bottom: 8px;
        }
        & > li {
          float: left;
          height: 24px;
          cursor: pointer;
          padding: 0 10px;
          text-align: center;
          margin: 9px 20px 0 0;
          line-height: 24px;
          color: #333333;
          border-radius: 2px;
          &.active,
          &:hover {
            color: #fff;
            background-color: #2b99ff;
          }
        }
      }
    }
    .search-list + .search-list {
      border-top: 1px solid #f2f2f2;
    }
  }
  .search-mid {
    box-sizing: border-box;
    padding: 10px 20px;
    width: 1200px;
    min-width: 1200px;
    margin: 10px auto 0;
    overflow: hidden;
    background-color: #fff;
    .search-size-group {
      float: left;
      & > span {
        float: left;
        box-sizing: border-box;
        padding: 0 12px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        border: 1px solid #ccc;
        cursor: pointer;
        color: #808080;
        & > i {
          font-size: 14px;
        }
        &:nth-child(2) {
          margin-left: -1px;
        }
        &.active {
          color: #2b99ff;
        }
      }
    }
    .search-totalSize {
      float: right;
      color: #ccc;
      font-size: 14px;
      line-height: 26px;
    }
  }
  .search-bot {
    position: relative;
    box-sizing: border-box;
    width: 1200px;
    min-width: 1200px;
    margin: 10px auto 0;
    overflow: hidden;
    background-color: #fff;
    .myLoading {
      width: 100%;
      position: absolute;
      top: 130px;
      text-align: center;
      z-index: 999999;
      i {
        font-size: 36px;
        color: #2b99ff;
      }
    }
    .search-question-list {
      .search-question-list-page {
        height: 60px;
      }
    }
    .search-question-list-empty {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 180px 0;
      text-align: center;
      line-height: 30px;
      background-color: #fff;
      & > p {
        font-size: 14px;
        color: #ccc;
        & > i {
          font-size: 70px;
          color: #ccc;
        }
      }
    }
  }
}
.shopping-cart-overNum-dialog {
  .el-dialog__header {
    padding: 0;
  }
  p:nth-child(1) {
    color: #f60;
    font-size: 40px;
    text-align: center;
  }
  p:nth-child(2) {
    font-size: 16px;
    color: #333;
    text-align: center;
    margin-top: 12px;
    line-height: 24px;
  }
}
</style>
